export default "__VITE_ASSET__CYtmsK21__"